import React, { Component } from "react";
// import logo from "./logo.svg";
import "./App.css";
// import { address } from "ip";
import services from "./services.json";
import _ from "lodash";

// declare var netlifyIdentity;
const netlifyIdentity = window.netlifyIdentity;

class App extends Component {
  state = {
    name: "",
    telephone: "",
    area: "",
    address: "",
    price: 0,
    finalPrice: 130,
    paymentDone: "no",
    services: [],
    selectedItems: [],
    hanimexUser: netlifyIdentity.currentUser()
  };

  handleChange(e) {
    e.target.classList.add("active");

    this.setState({
      [e.target.name]: e.target.value
    });

    this.showInputError(e.target.name);
  }

  handleSubmit = e => {
    console.log("component state", this.state);

    if (!this.showFormErrors()) {
      // console.log("form is invalid: do not submit");
      e.preventDefault();
    } 
    // else {
      // console.log("form is valid: submit");
      // let counter = 0;
      // const servicesElement = document.getElementById("services");
      // const servicesText = _.reduce(
      //   this.state.services,
      //   (sum, service) => {
      //     counter++;
      //     return sum + counter + "- " + service.name + "\n";
      //   },
      //   ""
      // );
      // servicesElement.value = servicesText;

      // const telephone = document.getElementById("telephone");
      // telephone.value = "2" + telephone.value;

      // e.preventDefault();
      // const form = document.getElementById("orderForm");
      // for (var i = 0; i < form.length; i++) {
      //   console.log(form[i].name + ": " + form[i].value);
      // }
    // }
  };

  showFormErrors() {
    const inputs = document.querySelectorAll("input, textarea, select");
    let isFormValid = true;

    inputs.forEach(input => {
      input.classList.add("active");

      const isInputValid = this.showInputError(input.name);

      if (!isInputValid) {
        isFormValid = false;
      }
    });

    return isFormValid;
  }

  showInputError(refName) {
    if (this.refs[refName]) {
      const validity = this.refs[refName].validity;
      const label = document.getElementById(`${refName}Label`).textContent;
      const error = document.getElementById(`${refName}Error`);

      if (refName === "telephone") {
        const telephone = this.refs[refName].value;
        var reg = /^\d+$/;
        var regHome = /^02/;
        var regMobile = /^01/;
        const invalid = document.getElementById("telephoneInvalid");
        if (
          reg.test(telephone) &&
          ((regMobile.test(telephone) && telephone.length === 11) || (regHome.test(telephone) && telephone.length === 10))
        ) {
          invalid.hidden = true;
          this.refs[refName].setCustomValidity("");
        } else {
          invalid.hidden = false;
          this.refs[refName].setCustomValidity("Invalid Telephone");
          return false;
        }
      }

      if (!validity.valid) {
        if (validity.valueMissing) {
          error.textContent = `يجب إدخال ${label}`;
        } else if (validity.typeMismatch) {
          error.textContent = `${label} غير صحيح`;
        }
        return false;
      }

      if (error) {
        error.textContent = "";
      }
    }
    return true;
  }

  netlifyLogout() {
    netlifyIdentity.logout();
  }

  netlifyLogin(user) {
    netlifyIdentity.open();
  }

  constructor(props) {
    super(props);
    netlifyIdentity.on("init", user => {
      this.setState({ hanimexUser: user });
    });
    netlifyIdentity.on("login", user => {
      this.setState({ hanimexUser: user });
    });
    netlifyIdentity.on("logout", () => {
      this.setState({ hanimexUser: null });
    });
    netlifyIdentity.on("error", err => {
      this.setState({ hanimexUser: null });
    });
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    return (
      <div className="App">
        {/* <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p> */}
        <br />
        <div className="container">
          {!this.state.hanimexUser ? (
            <div
              className="btn btn-clear centered btn-lg btn-block"
              id="buttonLogin"
              onClick={this.netlifyLogin}
            >
              Login
            </div>
          ) : (
            <div>
              <div
                className="btn btn-clear centered btn-lg btn-block"
                id="buttonLogout"
                onClick={this.netlifyLogout}
              >
                {this.state.hanimexUser.email} - خروج؟
              </div>
              <form id="orderForm" method="post">
                <input type="hidden" name="form-name" value="orderForm" />
                <div className="form-group row">
                  <label
                    htmlFor="name"
                    className="col-sm-2 col-form-label"
                    id="nameLabel"
                  >
                    الأسم
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      id="name"
                      name="name"
                      ref="name"
                      placeholder="الأسم"
                      required
                      value={this.state.name}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="nameError" />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="telephone"
                    className="col-sm-2 col-form-label"
                    id="telephoneLabel"
                  >
                    التليفون المحمول
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      id="telephone"
                      name="telephone"
                      ref="telephone"
                      placeholder="التليفون المحمول"
                      required
                      value={this.state.telephone}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="telephoneError" />
                    <div className="error" id="telephoneInvalid" hidden>
                      رقم التليفون غير صحيح
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="request"
                    className="col-sm-2 col-form-label"
                    id="requestLabel"
                  >
                    الخدمات المطلوبة
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      className="form-control"
                      id="request"
                      name="request"
                      ref="request"
                      placeholder="الخدمات المطلوبة"
                      required
                      value={this.state.request}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="requestError" />
                  </div>
                </div>
                
                <input
                  type="hidden"
                  name="partnerUser"
                  id="partnerUser"
                  value={this.state.hanimexUser.email}
                />
                <div className="form-group row">
                  <div className="col-sm-10">
                    <button
                      id="sub"
                      type="submit"
                      className="btn btn-primary"
                      onClick={this.handleSubmit}
                    >
                      التأكيد
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js